// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonMarkdownEditor = {
  emptyPreview: "暂无 Markdown 内容",
  modes: {
    edit: "编辑",
    split: "分屏",
    preview: "预览",
  },
  toolbar: {
    heading: "标题",
    bold: "加粗",
    italic: "斜体",
    quote: "引用",
    bulletList: "无序列表",
    orderedList: "有序列表",
    link: "链接",
    codeBlock: "代码块",
  },
  placeholders: {
    heading: "小节标题",
    bold: "加粗文本",
    italic: "斜体文本",
    quote: "引用内容",
    bulletList: "列表项",
    orderedList: "列表项",
    link: "链接文本",
    codeBlock: "代码",
  },
} as const;
